module.exports = __webpack_public_path__ + "static/media/icon-payment-methods-grid.a9160f95.png";